import { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { initMercadoPago, Payment } from '@mercadopago/sdk-react';
import { Button, Spin } from 'antd';
import { api } from '../../services/api';
import { useClient } from '../../context/ClientContext';

export const CheckoutMP = () => {
  const { id: pedidoId } = useParams();
  const { state } = useLocation();
  const { clientId , clientPath} = useClient();
  const navigate = useNavigate();

  const [checkoutData, setCheckoutData] = useState(null);
  const [sdkReady, setSdkReady] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const init = async () => {
      if (state?.publicKey && state?.total != null) {
        setCheckoutData({ publicKey: state.publicKey, total: state.total });
        return;
      }
      try {
        const res = await api.pagos.checkout(pedidoId);
        if (res.status === 'success') {
          setCheckoutData({ publicKey: res.data.public_key, total: res.data.total });
        } else {
          setError(res.message || 'No se pudo iniciar el pago');
        }
      } catch {
        setError('Error al conectar con el servidor');
      }
    };
    init();
  }, [pedidoId]); // eslint-disable-line

  useEffect(() => {
    if (checkoutData?.publicKey && !sdkReady) {
      initMercadoPago(checkoutData.publicKey, { locale: 'es-AR' });
      setSdkReady(true);
    }
  }, [checkoutData]); // eslint-disable-line

  if (error) {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <p style={{ color: '#666', marginBottom: 20 }}>{error}</p>
        <Button type="primary" onClick={() => navigate(clientPath('/carrito'))}>Volver al carrito</Button>
      </div>
    );
  }

  if (!sdkReady || !checkoutData) {
    return <div style={{ padding: 40, textAlign: 'center' }}><Spin size="large" /></div>;
  }

  const handleSubmit = async ({ formData }) => {
    const res = await api.pagos.procesarPago(pedidoId, formData);
    if (res.status === 'success') {
      const mpStatus = res.data?.mp_status;
      if (mpStatus === 'approved') {
        navigate(clientPath(`/pedido/exitoso?external_reference=${pedidoId}`));
      } else if (['pending', 'in_process', 'authorized'].includes(mpStatus)) {
        navigate(clientPath(`/pedido/pendiente?external_reference=${pedidoId}`));
      } else {
        navigate(clientPath(`/pedido/fallido?external_reference=${pedidoId}`));
      }
    } else {
      throw new Error(res.message || 'Error al procesar el pago');
    }
  };

  return (
    <div style={{ maxWidth: 700, margin: '40px auto', padding: '0 20px' }}>
      <h2 style={{ marginBottom: 24 }}>Completar pago</h2>
      <Payment
        initialization={{ amount: checkoutData.total }}
        customization={{ paymentMethods: { creditCard: 'all', debitCard: 'all' } }}
        onSubmit={handleSubmit}
        onError={(error) => console.error('[MP Brick]', error)}
      />
    </div>
  );
};
